var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageWithSidebar',{attrs:{"title":_vm.hero2,"crumbs":_vm.crumbs,"image":_vm.heroImage,"links":_vm.commonLinks.hair}})}
var staticRenderFns = []

export { render, staticRenderFns }